function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.022 1.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Accent"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.895429 0.895433 0 2 0H10.2C11.3046 0 12.2 0.895432 12.2 2C12.2 3.10457 11.3046 4 10.2 4L4 4L4 10.2C4 11.3046 3.10457 12.2 2 12.2C0.895431 12.2 0 11.3046 0 10.2V2Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 20C22 21.1046 21.1046 22 20 22H11.8C10.6954 22 9.79999 21.1046 9.79999 20C9.79999 18.8954 10.6954 18 11.8 18H18L18 11C18 9.89543 18.8954 9 20 9C21.1046 9 22 9.89543 22 11V20Z",
  fill: "#DE9EFF"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.762 1.877)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Outline"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.97654 1.50665C1.7806 1.50665 1.62176 1.6655 1.62176 1.86144V9.68752C1.62176 9.97183 1.39129 10.2023 1.10698 10.2023C0.822673 10.2023 0.592197 9.97183 0.592197 9.68752V1.86144C0.592197 1.09688 1.21199 0.47709 1.97654 0.47709H9.80263C10.0869 0.47709 10.3174 0.707566 10.3174 0.991872C10.3174 1.27618 10.0869 1.50665 9.80263 1.50665H1.97654ZM18.4983 18.738C18.6942 18.738 18.8531 18.5791 18.8531 18.3832L18.8531 9.68752C18.8531 9.40322 19.0835 9.17274 19.3679 9.17274C19.6522 9.17274 19.8826 9.40322 19.8826 9.68752L19.8826 18.3832C19.8826 19.1477 19.2628 19.7675 18.4983 19.7675H10.6722C10.3879 19.7675 10.1574 19.537 10.1574 19.2527C10.1574 18.9684 10.3879 18.738 10.6722 18.738H18.4983Z",
  fill: "#012CAD"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.13337 12.8801C5.5071 12.4817 4.76262 12.2531 3.96517 12.2587C1.75993 12.2741 -0.0152964 14.0743 9.93881e-05 16.2795C0.0154951 18.4848 1.81568 20.26 4.02092 20.2446C6.22617 20.2292 8.00139 18.429 7.98599 16.2238C7.97876 15.1887 7.57835 14.2484 6.9274 13.5435L13.5337 7.06759C14.2322 7.64706 15.131 7.99282 16.1095 7.98599C18.3148 7.97059 20.09 6.17041 20.0746 3.96517C20.0592 1.75993 18.259 -0.0152964 16.0538 9.93881e-05C13.8486 0.0154951 12.0733 1.81568 12.0887 4.02092C12.0947 4.87641 12.3693 5.66718 12.8319 6.31381L6.13337 12.8801ZM16.1024 6.95645C17.739 6.94502 19.0565 5.609 19.0451 3.97236C19.0337 2.33571 17.6976 1.01821 16.061 1.02964C14.4243 1.04107 13.1068 2.37709 13.1183 4.01373C13.1297 5.65038 14.4657 6.96788 16.1024 6.95645ZM4.01373 19.2151C5.65038 19.2036 6.96788 17.8676 6.95645 16.231C6.94502 14.5943 5.609 13.2768 3.97236 13.2882C2.33571 13.2997 1.01821 14.6357 1.02964 16.2723C1.04107 17.909 2.37709 19.2265 4.01373 19.2151Z",
  fill: "#012CAD"
})));

function SvgIconSyslog2Color(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSyslog2Color);
export default __webpack_public_path__ + "static/media/icon-syslog-2color.07aad87c47f0a819bb80ba3db57a107a.svg";
export { ForwardRef as ReactComponent };